import { render, staticRenderFns } from "./PaxCompatibilitesMare.vue?vue&type=template&id=d5f72ad4&"
import script from "./PaxCompatibilitesMare.vue?vue&type=script&lang=js&"
export * from "./PaxCompatibilitesMare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports